module.exports = __webpack_public_path__ + "img/ec.6130b769.svg";